import { vars } from '@sixfold/common-ui/dist/lib/css';
import { style } from '@vanilla-extract/css';

export const card = style({
  border: `1px solid ${vars.color.neutral.border.subtle}`,
  backgroundColor: vars.color.neutral.bg.accent.subtle.default,
});
